import {Component, Input, OnInit} from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core-v2';
import {EnumerationService} from '../../../services/enumeration.service';

@Component({
  selector: 'app-drawer-case-details',
  templateUrl: './drawer-case-details.component.html',
  styles: []
})
export class DrawerCaseDetailsComponent extends ExcTranslation implements OnInit {

  @Input() data: any | undefined = undefined;
  @Input() oeList: any[] | undefined = [];
  @Input() Schadenort: any | undefined = undefined;

  constructor(public enumSvc: EnumerationService) {
    super();
  }

  ngOnInit(): void {
  }

  getOEByID(ID: string): any {
    return ExcCoreModule.Array.GetObject(this.oeList, 'oeID', ID);
  }
  getKontaktaufnahmeVersucheArray(json: string): any[]
  {
    return JSON.parse(json);
  }


}
